// Re-export frontile forms to consolidate where logic is imported.
import {
  Input as FrontileInput,
  Textarea as FrontileTextarea,
  Checkbox,
  CheckboxGroup,
  Select,
  RadioGroup,
  Radio,
  Switch,
} from '@frontile/forms';
import type { ComponentLike } from '@glint/template';

type CompatInput = ComponentLike<{
  Args: {
    value?: unknown;
    onChange?: (value: string, event?: InputEvent) => void;
    onInput?: (value: string, event?: InputEvent) => void;
    [key: string]: unknown;
  };
  Element: HTMLInputElement;
}>;

type CompatTextarea = ComponentLike<{
  Args: {
    value?: unknown;
    onChange?: (value: string, event?: InputEvent) => void;
    onInput?: (value: string, event?: InputEvent) => void;
    [key: string]: unknown;
  };
  Element: HTMLTextAreaElement;
}>;

const Input = FrontileInput as unknown as CompatInput;
const Textarea = FrontileTextarea as unknown as CompatTextarea;

export { Input, Textarea, Checkbox, CheckboxGroup, Select, RadioGroup, Radio, Switch };
export { Form } from '@frontile/forms/components/form';

// Re-export FormResultData type from the form component
// NOTE: Using import/export pattern instead of direct re-export due to Vite build issue
// where "export type { FormResultData } from '@frontile/forms/components/form'"
// causes runtime error: "Indirectly exported binding name 'FormResultData' is not found"
import type { FormResultData as _FormResultData } from '@frontile/forms/components/form';
/**
 * Generic form result data type for strongly-typed form handling.
 * Use with your form data interface: FormResultData<YourFormDataType>
 *
 * @example
 * interface MyFormData {
 *   name: string;
 *   email: string;
 * }
 *
 * const handleSubmit = (result: FormResultData<MyFormData>) => {
 *   const data = result.data; // Properly typed without casting
 * }
 */
export type FormResultData<T = unknown> = _FormResultData<T>;

export { default as SearchInput } from './_private/search-input.gts';
